import {
  sendPostRequest, sendPutRequest, sendDeleteRequest, sendGetRequest
} from '../requests';

type OperatoryProps = {
  number: number,
  desc: string
}

type OperatoriesParams = {
  page: string,
  per_page: string
}

const baseUrl = '/operatories';

export const getOperatories = (params: OperatoriesParams) =>
  sendGetRequest(baseUrl, params);

export const getOperatoriesForFilters = () =>
  sendGetRequest(`${baseUrl}/list`);

export const addOperatory = (data: OperatoryProps) =>
  sendPostRequest(baseUrl, data);

export const updateOperatoryById = (id: string, body: OperatoryProps) =>
  sendPutRequest(`${baseUrl}/${id}`, body);

export const deleteOperatoryById = (id: number) =>
  sendDeleteRequest(`${baseUrl}/${id}`);

export const getOperatoriesOverviewList = () =>
  sendGetRequest(`${baseUrl}/overview/list`);

